import { WidgetViewModel } from '../../viewModel/viewModel';

export type SetCtaLoadingServiceAction = (serviceId: string) => void;

export const createSetCtaLoadingServiceAction = ({
  widgetViewModel,
  setProps,
}: {
  widgetViewModel: WidgetViewModel;
  setProps: Function;
}): SetCtaLoadingServiceAction => {
  return (serviceId) => {
    setProps({
      widgetViewModel: {
        ...widgetViewModel,
        ctaLoadingServiceId: serviceId,
      },
    });
  };
};
